"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCurrencyCents = exports.formatCurrencyDollars = exports.dollarsToCents = exports.centsToDollars = void 0;
const tslib_1 = require("tslib");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
const _CENTS_DOLLARS_CONVERSION_FACTOR = 100;
const centsToDollars = (cents) => lodash_1.default.round(cents / _CENTS_DOLLARS_CONVERSION_FACTOR, 2);
exports.centsToDollars = centsToDollars;
const dollarsToCents = (dollars) => lodash_1.default.round(dollars * _CENTS_DOLLARS_CONVERSION_FACTOR);
exports.dollarsToCents = dollarsToCents;
const formatCurrencyDollars = (dollars) => {
    return new Intl.NumberFormat('en-US', { currency: 'USD', style: 'currency' }).format(dollars);
};
exports.formatCurrencyDollars = formatCurrencyDollars;
const formatCurrencyCents = (cents) => (0, exports.formatCurrencyDollars)((0, exports.centsToDollars)(cents));
exports.formatCurrencyCents = formatCurrencyCents;
//# sourceMappingURL=money.js.map